import styled from 'styled-components'
import RedirectPage from 'components/Page/RedirectPage'

const RedirectToTeamPage = styled(props => <RedirectPage {...props} />)``

export default RedirectToTeamPage
